(() => {
  if (customElements.get('rebuild-footer')) return;
  class RebuildFooter extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.site-footer-block-menu')].map(block => {
        const trigger = block.querySelector('[data-accordion-trigger]');
        const button = block.querySelector('[data-rebuild-footer-toggle]');
        const label = block.querySelector('[data-rebuild-footer-label]');
        const content = block.querySelector('.site-footer-block-content');
        if (!trigger || !button || !label || !content || button.getAttribute('aria-controls') !== content.id) return null;
        return { trigger, button, label, content, inert: content.inert, ariaHidden: content.getAttribute('aria-hidden'), triggerTabindex: trigger.getAttribute('tabindex') };
      }).filter(Boolean);
      this.breakpoint = matchMedia('(min-width: 1024px)');
      this.sync = () => {
        for (const item of this.items) {
          const focusedButton = document.activeElement === item.button;
          const focusedContent = item.content.contains(document.activeElement);
          const state = item.trigger.dataset.accordionTrigger;
          const active = !this.breakpoint.matches && (state === 'open' || state === 'closed');
          item.button.hidden = !active;
          item.label.hidden = active;
          if (active) {
            const expanded = state === 'open';
            item.button.setAttribute('aria-expanded', String(expanded));
            item.content.inert = !expanded;
            item.content.setAttribute('aria-hidden', String(!expanded));
            if (!expanded && focusedContent) item.button.focus({ preventScroll: true });
          } else {
            item.button.removeAttribute('aria-expanded');
            this.restoreContent(item);
            if (focusedButton) {
              item.trigger.setAttribute('tabindex', '-1');
              item.trigger.focus({ preventScroll: true });
            }
          }
        }
      };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this, { subtree: true, attributes: true, attributeFilter: ['data-accordion-trigger'] });
      this.breakpoint.addEventListener('change', this.sync);
      this.sync();
    }
    restoreContent(item) {
      item.content.inert = item.inert;
      if (item.ariaHidden === null) item.content.removeAttribute('aria-hidden');
      else item.content.setAttribute('aria-hidden', item.ariaHidden);
    }
    disconnectedCallback() {
      this.observer.disconnect();
      this.breakpoint.removeEventListener('change', this.sync);
      for (const item of this.items) {
        item.button.hidden = true;
        item.button.removeAttribute('aria-expanded');
        item.label.hidden = false;
        this.restoreContent(item);
        if (item.triggerTabindex === null) item.trigger.removeAttribute('tabindex');
        else item.trigger.setAttribute('tabindex', item.triggerTabindex);
      }
    }
  }
  customElements.define('rebuild-footer', RebuildFooter);
})();
